export const currencies: any = {
    'default': '€',
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    '$': '$',
    '€': '€',
    '£': '£',
}
